import { useState} from "react";
import { useTranslation } from "react-i18next";
import { ArrowDownIcon } from "../Icons/ArrowDownIcon";
import { ArrowUpIcon } from "../Icons/ArrowUpIcon";
import { BagIcon } from "../Icons/BagIcon";
import { ExchangeLifecycleIcon } from "../Icons/ExchangeLifecycleIcon";
import { ChangeIcon } from "../Icons/ChangeIcon";
import {OrderHistoryCategory} from "../../Api/Models/orderhistory.model";
import { GalleryIcon } from "../Icons/GalleryIcon";
import GalleryModal from "../GalleryModal";




interface HistoryItemProps {
  date: String;
  history: OrderHistoryCategory;
}

const HistoryItem: React.FunctionComponent<HistoryItemProps> = ({
  date , history
                                                                }) => {
  const { t } = useTranslation();
  const [isContentVisible, setContentVisible] = useState(false);
  const [isOnboardingVisible, setOnboardingVisible] = useState(false);
  const [isExchangeVisible, setExchangeVisible] = useState(false);
  const [isReturnVisible, setReturnVisible] = useState(false);


  const toggleContentVisibility = () => {
    setContentVisible((prev) => !prev);
  };

  const toggleOnboardingVisibility = () => {
    setOnboardingVisible((prev) => !prev);
  };

  const toggleExchangeVisibility = () => {
    setExchangeVisible((prev) => !prev);
  };

  const toggleReturnVisibility = () => {
    setReturnVisible((prev) => !prev);
  };

  //const [galleryImages, setGalleryImages] = useState<string[] | null>(null);
  const [selectedType, setSelectedType] = useState<"assign" | "exchange" | "return" | null>(null);


  const showGallery = (type: "assign" | "exchange" | "return") => {
    setSelectedType(type);
  };
  


  return (

    <div className={"history-list-card mb-3" + (isContentVisible ? " history-list-card--opened" : "")}>
      <div
        onClick={toggleContentVisibility}
        className="flex justify-between items-center gap-2"
      >
        <div className="history-list-card__date">
          {date}
        </div>
        <div>
          <div className="rounded-toggler-icon">
            {isContentVisible ? <ArrowUpIcon width={14} height={7}/> : <ArrowDownIcon width={14} height={7}/>}
          </div>
        </div>
      </div>

      {isContentVisible && (
          <div className="content mt-2">
            {history && history.assign && history.assign.length > 0 && (
            <div className="history-list-item">
                <div
                    onClick={toggleOnboardingVisibility}
                    className="flex justify-between items-center"
                >
                    <div className="flex items-center gap-2">
                        <BagIcon/>
                        {t("Onboarding")}
                    </div>
                    {isOnboardingVisible ? <ArrowUpIcon/> : <ArrowDownIcon/>}
                </div>

                {isOnboardingVisible && (
                  <div className="flex justify-between items-center gap-2">
                    <div className="mt-2 text-medium">
                        {history.assign.length > 0 ? (
                            history.assign.map((item, index) => (
                                <div key={index}>
                                    <strong>{item.product_name}</strong> <span
                                    className="color-light">by {item.assigned_by}</span>
                                </div>
                            ))
                      ) : (
                          <p className="color-light">{t("No assigned items")}</p>
                      )}
                    </div>

                    {history.unique_images_by_type.assign.length > 0 && (
                        <div>
                          <div
                              className="icon-button"
                              onClick={() => showGallery("assign")}
                          >
                            <GalleryIcon />
                          </div>
                        </div>
                    )}
                  </div>
                  )}
                </div>
            )}

            {history && history.exchange && history.exchange.length > 0 && (
                <div className="history-list-item">
                  <div
                      onClick={toggleExchangeVisibility}
                      className="flex justify-between items-center"
                  >
                    <div className="flex items-center gap-2">
                      <ChangeIcon />
                      {t("Exchange")}
                    </div>
                    {isExchangeVisible ? <ArrowUpIcon /> : <ArrowDownIcon />}
                  </div>

                  {isExchangeVisible && (
                    <div className="flex justify-between items-center gap-2">
                      <div className="mt-2 text-medium">
                        {history.exchange.map((item, index) => (
                            <div key={index}>
                              <strong>{item.product_name}</strong> <span className="color-light">by {item.assigned_by}</span>
                            </div>
                        ))}
                      </div>

                      {history.unique_images_by_type.exchange.length && (
                        <div>
                          <div
                              className="icon-button"
                              onClick={() => {
                                showGallery("exchange");
                              }}
                          >
                            <GalleryIcon />
                          </div>
                          
                        </div>
                      )}
                    </div>
                  )}
                </div>
            )}

            {history && history.return && history.return.length > 0 && (
            <div className="history-list-item">
              <div
                  onClick={toggleReturnVisibility}
                  className="flex justify-between items-center"
              >
                <div className="flex items-center gap-2">
                  <ExchangeLifecycleIcon/>
                  {t("Return")}
                </div>
                {isReturnVisible ? <ArrowUpIcon/> : <ArrowDownIcon/>}
              </div>

              {isReturnVisible && (
                <div className="flex justify-between items-center gap-2">
                  <div className="mt-2 text-medium">
                    {history.return.length > 0 ? (
                        history.return.map((item, index) => (
                            <div key={index}>
                              <strong>{item.product_name}</strong> <span className="color-light">by {item.assigned_by}</span>
                            </div>
                        ))
                    ) : (
                        <p className="color-light">{t("No returned items")}</p>
                    )}
                  </div>

                  {history.unique_images_by_type.return.length && (
                      <div>
                        <div
                            className="icon-button"
                            onClick={() => {
                              showGallery("return");
                            }}
                        >
                          <GalleryIcon />
                        </div>

                      </div>
                  )}
                </div>
              )}
            </div>
                )}

          </div>
      )}

      {selectedType && (
          <GalleryModal
              images={history.unique_images_by_type[selectedType].map((entry) => entry.image)}
              onClose={() => setSelectedType(null)}
          />
      )}


    </div>

  );
};

export default HistoryItem;
